module.exports = __webpack_public_path__ + "assets/retina_90RotationCCWDetailed.894cbd7cdbcf45c7659ac0f2e341deb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_90RotationCCWDetailed.png
// module id = 604
// module chunks = 0